import { Vehicle } from '../../../../types/vehicle';

export function createBlankVehicle(fleetVehicles: Vehicle[]): Vehicle {
  const id = `vehicle-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
  const name = `Vehicle ${fleetVehicles.length + 1}`;
  return {
    id,
    name,
    standardSeats: 0,
    wheelchairSeats: 0,
    startLocation: '',
    endLocation: '',
    operatingHours: [],
  };
}

/**
 * Creates a new Vehicle inheriting attributes (seats, location, operating
 * hours) from the last vehicle in the list. Used for the "add another like
 * this one" affordance below the timeline. Falls back to a blank vehicle if
 * the list is empty.
 */
export function cloneLastVehicle(fleetVehicles: Vehicle[]): Vehicle {
  const last = fleetVehicles[fleetVehicles.length - 1];
  if (!last) return createBlankVehicle(fleetVehicles);
  const id = `vehicle-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
  return {
    ...last,
    id,
    name: `Vehicle ${fleetVehicles.length + 1}`,
    operatingHours: last.operatingHours.map(period => ({
      ...period,
      breaks: (period.breaks ?? []).map(br => ({ ...br })),
    })),
  };
}
